// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateVendorItemPriceMutation($input: UpdateVendorItemPriceInput!) {
    updateVendorItemPrice(input: $input) {
      vendorItemPrice {
        id
        vendor {
          id
        }
        item {
          id
          name
        }
        unitPrice
        leadTimeDays
        isPreferred
        createdAt
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
